import { Outlet } from 'react-router-dom';
import { ToastViewport } from '@/components/ui';
import { useAuthState } from '@/lib/auth/authStore';
import { useLockState } from '@/lib/auth/lockStore';
import { LockedPage } from '@/features/system/LockedPage';
import { RouteChrome } from './RouteChrome';

/** Root: toasts + the full-screen system lock (super_admin is never locked out). */
export function RootLayout() {
  const lock = useLockState();
  const { user } = useAuthState();
  const locked = lock.locked && user?.role !== 'super_admin';
  return (
    <>
      <RouteChrome />
      {locked ? <LockedPage /> : <Outlet />}
      <ToastViewport />
    </>
  );
}
